import { createAction } from 'redux-actions';

export const LOGGED_IN = 'LOGGED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';
export const CLEAR_AUTH_REDUCER = 'CLEAR_AUTH_REDUCER';

export const loggedIn = createAction(LOGGED_IN);
export const loggedOut = createAction(LOGGED_OUT);
export const clearAuthReducer = createAction(CLEAR_AUTH_REDUCER);
